import React from "react"
import clsx from "clsx"
import { Link as GatsbyLink } from "gatsby"

import {
  Box,
  Link,
  List,
  ListItem,
  makeStyles,
  useTheme,
  Button,
} from "@material-ui/core"

import logoMobile from "../images/logo-mobile.png"

const useStyles = makeStyles(theme => ({
  link: {
    justifyContent: "center",
    margin: "20px 0",
    color: theme.colors.green[700],
  },
  logo: {
    margin: "30px 0",
  },
  phone: {
    textDecoration: "underline",
  },
  contact: {
    margin: "28px 0",
  },
}))

const NavMobile = () => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Box role="presentation">
      <List component="nav" aria-label="home about 17788893619">
        <ListItem
          disableGutters
          className={clsx(classes.link, classes.logo)}
          component={GatsbyLink}
          to="/"
        >
          <img src={logoMobile} alt="Efficient Accounting Services LTD." />
        </ListItem>
        <ListItem
          disableGutters
          className={classes.link}
          component={GatsbyLink}
          to="/about"
        >
          ABOUT
        </ListItem>
        <ListItem
          disableGutters
          className={clsx(classes.link, classes.phone)}
          component={Link}
          href={theme.data.phoneHref}
        >
          {theme.data.uiPhone}
        </ListItem>
        <ListItem
          disableGutters
          className={clsx(classes.link, classes.contact)}
        >
          <Button
            color="primary"
            variant="contained"
            href={theme.data.emailHref}
          >
            CONTACT US
          </Button>
        </ListItem>
      </List>
    </Box>
  )
}

export default NavMobile
